import axios from "axios";
import firebase from "../auth/firebase";
import { appVersion, getStorage } from "../auth/utils";

// Optional Messenger traffic must never run Manager's global auth interceptors.
const client = axios.create();

export async function requestIntercomMessengerSession(clubId, {
  expectedFirebaseUid, signal, timeout = 10000,
} = {}) {
  const assertCurrent = () => {
    const storage = getStorage();
    if (signal?.aborted || !expectedFirebaseUid || !storage.getItem("token") ||
        storage.getItem("firebaseUid") !== expectedFirebaseUid ||
        storage.getItem("activeClubId") !== String(clubId) || storage.getItem("impersonate") ||
        firebase.auth().currentUser?.uid !== expectedFirebaseUid) {
      throw new Error("INTERCOM_SESSION_IDENTITY_CHANGED");
    }
  };
  assertCurrent();
  // Firebase refreshes expired tokens here. No storage writes, forced Manager
  // refresh, logout, redirects, or credential logging on an optional failure.
  const token = await firebase.auth().currentUser.getIdToken();
  assertCurrent();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  if (!baseUrl || typeof token !== "string" || !token) throw new Error("INTERCOM_SESSION_UNAVAILABLE");
  const response = await client.post(`${baseUrl.replace(/\/+$/, "")}/intercom/messenger-session`, { clubId }, {
    signal, timeout,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-app-version": appVersion,
      "x-club-id": String(clubId),
    },
  });
  assertCurrent();
  return response;
}
